import { Box, Button, Typography } from '@mui/material';
import {
  accountBox,
  balanceAmount,
  balanceText,
  bottomBtns,
  customStyles,
  docInfoBox,
  docInfoText,
  infoBox,
  labelStyle,
  lineBorder,
} from './AccountsBox.sx';
import Select from 'react-select';
import SelectValueContainer from 'app/components/SelectValueContainer';
import { SelectOption } from 'app/components/SelectOption';
import DashboardWarningIcon from 'app/components/Icons/DashboardWarningIcon';
import { green, green1, green2, grey3 } from 'app/components/ThemeProvider/colors';
import IncomingPlus from 'app/components/Icons/IncomingPlus';
import React from 'react';
import useAccountsBox from './useAccountsBox';
import ExtractModal from 'app/components/ExtractModal';
import useCurrencySymbol from 'app/utils/customHooks/useCurrencySymbol';
import { Accounts, AccountValue } from 'app/constants/types';
import RequesiteModal from 'app/components/RequisiteModal/RequesiteModal';
import logger from 'app/utils/logger';

interface Props {
  accounts: Accounts[];
  expand: boolean;
  selectedValue: AccountValue;
  changeSelectedValue: (data: AccountValue) => void;
  homePageFlag?: (flag: boolean) => void;
}

const AccountsBox = (props: Props) => {
  const { expand, accounts, selectedValue, changeSelectedValue, homePageFlag } = props;

  const {
    t,
    account,
    isOpenMenu,
    wrapperRef,
    setIsOpenMenu,
    // isOptionSelected,
    // getOptions,
    // getValue,
    onChange,
    navigateToOrders,
    navigateToTransfer,
  } = useAccountsBox({ accounts, selectedValue, changeSelectedValue, homePageFlag });

  logger.log(selectedValue);

  return (
    <>
      <Box sx={accountBox} onClick={() => setIsOpenMenu(!isOpenMenu)} ref={wrapperRef}>
        <label style={labelStyle}>{t('homePage.account')}</label>
        <Select
          // options={getOptions()
          options={account}
          // isMulti={true}
          components={{
            IndicatorSeparator: () => null,
            MultiValueRemove: () => null,
            ValueContainer: SelectValueContainer,
            Option: SelectOption,
          }}
          styles={customStyles}
          isSearchable={false}
          menuIsOpen={isOpenMenu}
          isClearable={false}
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          // value={getValue()}
          value={selectedValue}
          onChange={onChange}
          // isOptionSelected={isOptionSelected}
        />
      </Box>
      <Box sx={{ mb: '24px' }}>
        <Typography sx={balanceText}>{t('homePage.balance')}</Typography>
        <Box sx={{ display: 'flex', gap: '32px' }}>
          <Typography sx={balanceAmount}>
            {selectedValue?.balance} {useCurrencySymbol(selectedValue?.currency)}
          </Typography>
          {selectedValue?.have_tax_order === 'YES' && (
            <Box sx={docInfoBox} onClick={navigateToOrders}>
              <DashboardWarningIcon />
              <Typography sx={docInfoText}>{t('homePage.taxOrders')}</Typography>
            </Box>
          )}
        </Box>
      </Box>
      <Box sx={lineBorder}></Box>
      <Box sx={infoBox(expand)}>
        {/*<Box>*/}
        {/*  <Typography sx={{ color: grey3, fontSize: '17px' }}>{t('homePage.available')}</Typography>*/}
        {/*  <Typography sx={{ color: green, fontSize: '22px', fontWeight: '600' }}>*/}
        {/*    {+selectedValue?.blocked > +selectedValue?.balance ? 0 : +selectedValue?.balance - +selectedValue?.blocked}{' '}*/}
        {/*    {useCurrencySymbol(selectedValue?.currency)}*/}
        {/*  </Typography>*/}
        {/*</Box>*/}
        <Box>
          <Typography sx={{ color: '#7B7E81', fontSize: '17px' }}>{t('homePage.blocked')}</Typography>
          <Typography sx={{ color: '#FF5F57', fontSize: '22px', fontWeight: '600' }}>
            {selectedValue?.blocked} {useCurrencySymbol(selectedValue?.currency)}
          </Typography>
        </Box>
        {selectedValue?.goverment_amount > 0 && (
          <Box>
            <Typography sx={{ color: '#7B7E81', fontSize: '17px' }}>Dövlət vəsaiti</Typography>
            <Typography sx={{ color: '#FF9E1F', fontSize: '22px', fontWeight: '600' }}>
              {selectedValue?.goverment_amount} {useCurrencySymbol(selectedValue?.currency)}
            </Typography>
          </Box>
        )}
      </Box>
      <Box sx={bottomBtns}>
        <Button
          sx={{ display: 'flex', gap: '12px', color: green, background: green1, '&:hover': { background: green2 } }}
          onClick={navigateToTransfer}
        >
          <IncomingPlus />
          {t('homePage.outflow')}
        </Button>
        <RequesiteModal accountValue={selectedValue?.value} accountCurrency={selectedValue?.currency} />
        <ExtractModal accountsList={accounts} accountValue={selectedValue?.value} />
      </Box>
    </>
  );
};

export default AccountsBox;
